// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const swinub: PokeData = {
  "id": 220,
  "name": "swinub",
  "height": 4,
  "weight": 65,
  "base_experience": 50,
  "types": [
    PokeType.ICE,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "mist",
    "blizzard",
    "earthquake",
    "amnesia",
    "flail",
    "powder-snow",
    "mud-slap",
    "icy-wind",
    "endure",
    "ancient-power",
    "mud-sport",
    "odor-sleuth",
    "ice-shard",
    "mud-bomb",
    "bulldoze",
    "icicle-crash",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "blizzard",
    "earthquake",
    "mud-slap",
    "ancient-power",
    "ice-shard",
    "mud-bomb",
    "fissure",
    "icicle-dagger",
    "bonemerang",
    "hailstorm",
    "magnitude",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 112,
    "item": null,
    "species": [
      {
        "name": "swinub",
        "order": 251,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "piloswine",
        "order": 252,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 220,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "mamoswine",
        "order": 253,
        "types": [
          PokeType.ICE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 221,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "ancient-power"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 50,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
